// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zbhP","delete":"styles_delete__1hxS7","update":"styles_update__3epUz","add":"styles_add__2LuBA"};